import React from "react";
import classNames from "classnames";
import styles from "../../../../../../styles/Campaigns/CampaignLogs.module.scss";
import InfoBlock from "../../../../../common/InfoBlock";
import { LogRenderContext } from "../LogRenderer";
import GetUpdatedOnBy from "../GetUpdatedOnBy";
import { formatDateTimeWithTz } from "../../../../../../utils/formatDateTimeWithTz";

const Cancelled = ({ name, id, updatedBy, updatedAt }) => {
  const { log, userTimeZone } = React.useContext(LogRenderContext);
  const { statusChangeRequest } = log.changedFields;
  return (
    <div className={styles.tabContainer}>
      <div className={styles.badgeContainer}>
        <div className={styles.campaignName}>{name}</div>
        <div className={classNames(styles.badge, styles.badgeError)}>
          <div>Cancelled</div>
        </div>
      </div>
      <GetUpdatedOnBy updatedBy={updatedBy} updatedAt={updatedAt} />
      <InfoBlock
        header="Cancellation Details"
        className={styles.changeTracking}
        config={[
          {
            title: "Cancelled From",
            size: {
              sm: 6,
              xs: 6,
            },
            value: statusChangeRequest?.fromDate
              ? formatDateTimeWithTz(statusChangeRequest.fromDate, userTimeZone)
              : undefined,
          },
          {
            title: "Reason",
            size: {
              sm: 6,
              xs: 6,
            },
            value: statusChangeRequest?.reason,
          },
          {
            title: "Comments",
            size: {
              sm: 6,
              xs: 6,
            },
            value: statusChangeRequest?.comments,
          },
          {
            title: "Name & ID",
            size: {
              sm: 6,
              xs: 6,
            },
            value: `${name} (${id})`,
          },
        ]}
      />
    </div>
  );
};

export default Cancelled;
